module.exports = __webpack_public_path__ + "006fdc0abb5cc197ad74279b38594c25.png";